import React from "react";
import { useErrorBoundary } from "react-error-boundary";
import { isNil } from "ramda";

import { Layout } from "affinityUI/structures/layout";
import { Roles } from "components/views/roles";
import { useGetRolesQuery } from "gql";

export const RolesPage: React.FC = () => {
  const { showBoundary: onError } = useErrorBoundary();
  const { data: rolesData, loading: loadingRoles } = useGetRolesQuery({ onError });
  const roles = rolesData?.roles;
  return (
    <Layout title="User roles" showBackBtn loading={loadingRoles}>
      {!isNil(roles) && <Roles roles={roles} />}
    </Layout>
  );
};
